import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';

export const PROJECT_RESOURCE_DROPDOWN_OPTIONS_QUERY = gql`
  query pageOfProjectResourceDropdownOptions(
    $input: PageOfProjectResourceDropdownOptionsInput
    $includeAvailability: Boolean!
    $includeUserRate: Boolean!
    $includeAllocatedResource: Boolean!
    $includeAssignedToTask: Boolean!
  ) {
    pageOfProjectResourceDropdownOptions(input: $input) {
      dropdownOptions {
        id
        displayText
        roles {
          isPrimary
          projectRole {
            uri
            name
          }
        }
        availableDuration: netAvailableDuration
          @include(if: $includeAvailability)
        isAllocatedResource @include(if: $includeAllocatedResource)
        isAssignedToTask @include(if: $includeAssignedToTask)
        userRateInProjectCurrency @include(if: $includeUserRate) {
          amount
          currency {
            id
            displayText
          }
        }
      }
      paginationToken
    }
  }
`;

const DEFAULT_PAGE_SIZE = 200;

export const usePageOfProjectResourceDropdownOptions = ({
  isAvailabilityEnabled,
  projectId,
  page = 1,
  pageSize = DEFAULT_PAGE_SIZE,
  searchTerm,
  availabilityPercentageInRange,
  skip = false,
  assignedTaskId,
  includeUserRate = false,
  includeAllocatedResource = true,
  includeAssignedToTask = true
}) => {
  const { loading, data } = useQuery(PROJECT_RESOURCE_DROPDOWN_OPTIONS_QUERY, {
    fetchPolicy: 'network-only',
    variables: {
      input: {
        projectId,
        page,
        pageSize,
        assignedTaskId,
        filter: {
          searchTerm,
          availabilityPercentageInRange
        }
      },
      includeAvailability: isAvailabilityEnabled,
      includeUserRate,
      includeAllocatedResource,
      includeAssignedToTask
    },
    context: {
      debounceKey: 'project-resource-dropdown-options',
      debounceTimeout: 250
    },
    skip
  });

  return {
    loading,
    users: data?.pageOfProjectResourceDropdownOptions.dropdownOptions || [],
    hasMore: Boolean(data?.pageOfProjectResourceDropdownOptions.paginationToken)
  };
};

export default usePageOfProjectResourceDropdownOptions;
